import { Button, Card, Checkbox, Text } from "../../../../components";
import Localization from "../../../../localization";
import { useTheme } from "styled-components";
import useViewModel from "../../viewModel";
import { Enums } from "../../../../utils";
import { useState } from "react";
import { Flex } from "antd";

const Options = ({ onDone = () => {} }) => {
  const {
    device,
    alarmSMS,
    modifyDeviceAlarmRecipientCategories = () => {},
  } = useViewModel();
  const [categories, setCategories] = useState(
    (alarmSMS?.categories ?? []).filter((_) => _.enabled).map((_) => _.category)
  );
  const theme = useTheme();

  return (
    <div>
      <Card
        bordered
        title={`${alarmSMS?.totalSentThisMonth ?? 0} ${
          Localization.general.sms
        }`}
        extra={
          <Flex align="center">
            <Text
              weight={600}
              type="secondary"
              children={Localization.service.alarmSMS_options_total_desc}
            />
          </Flex>
        }
      />
      {device.supportsSignals && (
        <Card
          className="m-30-t"
          classNames={{ body: "p-20" }}
          style={{ background: theme.token.surface.primary }}
        >
          <Text
            level={5}
            weight={700}
            type="secondary"
            className="m-15-b"
            children={Localization.service.alarmSMS_options_categories_title}
          />
          <Checkbox.Group
            vertical
            value={categories}
            onChange={setCategories}
            options={Object.values(Enums.alarmSMScategories).map((value) => ({
              label: Enums.details("alarmSMScategories", value)?.name ?? "",
              value: value,
            }))}
          />
        </Card>
      )}
      <Button
        type="primary"
        className="m-30-t"
        title={Localization.general.done}
        onClick={async () => {
          if (device.supportsSignals)
            await modifyDeviceAlarmRecipientCategories(categories);
          onDone();
        }}
      />
    </div>
  );
};

export default Options;
